import Swal from "sweetalert2";
import { clearCatalogProductsAv, clearRequestsMemory, clearRequestsPDF, processRequest, setDetailRequest, setDetailRequestPDF, setError, setProductsAv, setRequests } from "./slice";
import apiConnection from "../../Connection";
import { getDateHour } from "../../../utils/DateHour";
import { getFirstDayCurrentMonth, getLastDayCurrentMonth } from "../../../utils/Custom";


const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    didOpen: (toast) => {
        // toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});

// Variables globales
let firstDayX = getFirstDayCurrentMonth(); let lastDayX = getLastDayCurrentMonth(); let statusOrderX = 0;



// Lectura de Ordenes y detalles 
export const loadRequests = (firstDay, lastDay, statusOrder) => {
    return async (dispatch, getState) => {
        dispatch(clearRequestsPDF());
        dispatch(clearRequestsMemory());
        dispatch(processRequest());
        await apiConnection.get(`/Orders/getListOrdersRequest/${firstDay}/${lastDay}/${statusOrder}`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setRequests({
                        msg: 'Listado de Productos cargado',
                        catalog: response.data.data,
                    })
                );
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

export const loadDetailRequest = (folio) => {
    return async (dispatch, getState) => {
        dispatch(clearRequestsPDF());
        dispatch(clearRequestsMemory());
        dispatch(processRequest());
        await apiConnection.get(`/Orders/getOrdersRequestByID/${folio}`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setDetailRequest({
                        msg: 'Orden  encontrado',
                        detail: response.data.data,
                        items: response.data.items,
                    })
                );
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

export const loadHistoryRequest = (folio) => {
    return async (dispatch, getState) => {
        dispatch(clearRequestsPDF());
        dispatch(clearRequestsMemory());
        dispatch(processRequest());
        await apiConnection.get(`/Orders/getHistoryOrderRequest/${folio}`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setDetailRequest({
                        msg: 'Orden  encontrado',
                        detail: response.data.order,
                        items: response.data.items,
                    })
                );
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

// Generacion de impresion de orden de compra
export const loadDetailRequestPDF = (folio) => {
    return async (dispatch, getState) => {
        dispatch(clearRequestsPDF());
        dispatch(processRequest());
        await apiConnection.get(`/Orders/getOrdersRequestByID/${folio}`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setDetailRequestPDF({
                        msg: 'Orden encontrado',
                        detail: response.data.data,
                        items: response.data.items,
                    })
                );
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

// Crear nueva solicitud
export const loadProductsAvaliable = () => {
    return async (dispatch, getState) => {
        dispatch(clearCatalogProductsAv());
        dispatch(processRequest());
        await apiConnection.get(`/Orders/getListProducts`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setProductsAv({
                        msg: 'Listado de Productos cargado',
                        catalog: response.data.data,
                    })
                );
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

export const newRequest = (data, userName, notes) => {
    return async (dispatch, getState) => {
        const { fecha, hora, fuente } = await getDateHour();

        dispatch(processRequest());
        await apiConnection.post(`/Orders/postOrderRequest`, {
            USERREGISTER: userName,
            DATEREGISTER: fecha,
            HOURREGISTER: hora,
            NOTES: notes,
            PRODUCTS: data,
            STATUSID: '1',
            CREATED_AT: fecha,
            UPDATED_AT: fecha,

        }).then(function (response) {
            if (response.data.status = 200) {

                Swal.fire({
                    title: "Atencion",
                    text: `Orden de compra registrada con el Folio ${response.data.folio}`,
                    icon: "success",
                    confirmButtonText: "Aceptar",
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: "btn btn-primary ", // <-- Personaliza aquí
                    }
                });
                dispatch(loadProductsAvaliable());
            }
        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se registro la orden de compra... favor de intentar de Nuevo'
            })
            dispatch(loadProductsAvaliable());
            return;
        });

    }
}

// Cambio de estado de ordenes, cancelacion y cierre
export const changedState = (userName, id, estado) => {
    return async (dispatch, getState) => {
        const { fecha, hora, fuente } = await getDateHour();

        dispatch(processRequest());
        await apiConnection.put(`/Orders/putOrderRequestState`, {
            USERNAME: userName,
            DATE: fecha,
            HOUR: hora,
            ORDER: id,
            STATE: estado

        }).then(function (response) {
            if (response.data.status = 200) {

                if (estado != 6 || estado != 7) {
                    Swal.fire({
                        title: "Atencion",
                        text: `Estado de la Orden actualizada`,
                        icon: "success",
                        confirmButtonText: "Aceptar",
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: "btn btn-primary ", // <-- Personaliza aquí
                        }
                    });
                    dispatch(loadDetailRequest(id));
                }


                if (estado == 6) {
                    Swal.fire({
                        title: "Atencion",
                        text: `Orden de compra, MARCADA como recibida por COMPLETO`,
                        icon: "success",
                        confirmButtonText: "Aceptar",
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: "btn btn-primary ", // <-- Personaliza aquí
                        }
                    });
                    dispatch(loadRequests(firstDayX, lastDayX, statusOrderX));
                }

                if (estado == 7) {
                    Swal.fire({
                        title: "Atencion",
                        text: `Orden de compra, MARCADA como CANCELADA`,
                        icon: "success",
                        confirmButtonText: "Aceptar",
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: "btn btn-primary ", // <-- Personaliza aquí
                        }
                    });
                    dispatch(loadRequests(firstDayX, lastDayX, statusOrderX));
                }



            }
        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se actualizo el estado de la orden de compra... favor de intentar de Nuevo'
            })
            dispatch(loadRequests(firstDayX, lastDayX, statusOrderX));
            return;
        });

    }
}

// Aprobacion de ordenes
export const editRequest = (data, userName, id, estado) => {
    return async (dispatch, getState) => {
        const { fecha, hora, fuente } = await getDateHour();

        dispatch(processRequest());
        await apiConnection.put(`/Orders/putOrderRequest/${id}`, {
            USERREVIEW: userName,
            DATEREVIEWER: fecha,
            HOURREVIEWER: hora,
            PRODUCTS: data,
            STATUSID: estado,
            UPDATED_AT: fecha,

        }).then(function (response) {
            if (response.data.status = 200) {

                if (estado == 3) {
                    Swal.fire({
                        title: "Atencion",
                        text: `Orden de compra, APROBADA`,
                        icon: "success",
                        confirmButtonText: "Aceptar",
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: "btn btn-primary ", // <-- Personaliza aquí
                        }
                    });
                }

                if (estado == 7) {
                    Swal.fire({
                        title: "Atencion",
                        text: `Orden de compra, RECHAZADA`,
                        icon: "success",
                        confirmButtonText: "Aceptar",
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: "btn btn-primary ", // <-- Personaliza aquí
                        }
                    });
                }
                dispatch(loadRequests(firstDayX, lastDayX, statusOrderX));
            }
        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se actualizo el estado de la orden de compra... favor de intentar de Nuevo'
            })
            dispatch(loadRequests(firstDayX, lastDayX, statusOrderX));
            return;
        });

    }
}

// Recibir la orden
export const receiveRequest = (data, userName, id, estado) => {
    return async (dispatch, getState) => {
        const { fecha, hora, fuente } = await getDateHour();
        dispatch(processRequest());

        await apiConnection.put(`/Orders/putOrderRequestReceived/${id}`, {
            USERNAME: userName,
            DATEREGISTER: fecha,
            HOURREGISTER: hora,
            PRODUCTS: data,
            STATUSID: estado,
            UPDATED_AT: fecha,

        }).then(function (response) {
            if (response.data.status = 200) {

                if (estado == 5) {
                    Swal.fire({
                        title: "Atencion",
                        text: `Orden de compra, recibida de manera parcial`,
                        icon: "success",
                        confirmButtonText: "Aceptar",
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: "btn btn-primary ", // <-- Personaliza aquí
                        }
                    });
                }

                if (estado == 6) {
                    Swal.fire({
                        title: "Atencion",
                        text: `Orden de compra, recibida por completo`,
                        icon: "success",
                        confirmButtonText: "Aceptar",
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: "btn btn-primary ", // <-- Personaliza aquí
                        }
                    });
                }

                dispatch(loadRequests(firstDayX, lastDayX, statusOrderX));
            }
        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se registro la recepcion de la Orden... favor de intentar de Nuevo'
            })
            dispatch(loadRequests(firstDayX, lastDayX, statusOrderX));
            return;
        });

    }
}
